import {createAction} from "@reduxjs/toolkit";

export const openModal = createAction('OPEN_MODAL');